import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import CommonButton from "../../../../components/buttons/CommonButton";
import CommonInput from "../../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../../helpers/handleFormChanges";
import CommonSelect from "../../../../components/forms/CommonSelect";
import CommonInputValor from "../../../../components/forms/CommonInputValor";
import CommonInputDate from "../../../../components/forms/CommonInputDate";
import CommonInputFile from "../../../../components/forms/CommonInputFile";
import PropTypes from "prop-types";
import useTipos from "../../../../hooks/common/useTipos";

function NovoImposto({
  modalHook,
  valuesHook,
  salvaImposto,
  getDadosArquivo,
  anoInicial,
  anoFinal,
}) {
  const { novoImpostoModal, setNovoImpostoModal } = modalHook;
  const { values, setValues } = valuesHook;
  const tiposImpostos = useTipos("impostos")

  return (
    <CommonModal
      title="Novo imposto"
      is_open_modal={novoImpostoModal}
      set_is_open_modal={setNovoImpostoModal}
      size="xl"
      buttons={
        <CommonButton
          key={`upload-imposto`}
          color="success"
          onClick={() => {
            salvaImposto();
          }}
        >
          Upload
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-3 mb-3">
          <CommonInput
            label="Descrição"
            id="descricao"
            value={values.descricao}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonSelect
            label="Categoria"
            id="categoria"
            value={values.categoria}
            onChange={(e) => {
              handleChange(e, values, setValues);
              if (values?.arquivo)
                getDadosArquivo({ categoria: e.target.value });
            }}
            data={tiposImpostos.map((imposto) => ({
              text: imposto.valor,
              id: imposto.chave,
            }))}
            placeholder="Selecione a identificação"
            required
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputValor
            label="Valor"
            id="valor"
            value={values.valor}
            onChange={(e) => {
              handleChangeNameValue("valor", e.target.value, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputDate
            label="Vencimento"
            id="vencimento"
            value={values.vencimento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
            min={`${anoInicial}-01-01`}
            max={`${anoFinal}-12-31`}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInput
            label="Código de barras"
            id="codigoBarras"
            value={values.codigoBarras}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputFile
            label="Selecione o arquivo"
            id="arquivo"
            onChange={(e) => {
              handleChangeNameValue(
                "arquivo",
                e.target.files[0],
                values,
                setValues
              );
              if (values?.categoria)
                getDadosArquivo({ arquivo: e.target.files[0] });
            }}
            accept="application/pdf"
            required
          />
        </div>
      </div>
      <div className="row pt-4">
        <div className="col-12">
          <label>
            Para preenchimento automático selecione primeiro a
            &quot;Categoria&quot;, somente em seguida selecione o arquivo para
            upload e aguarde um instante.
          </label>
        </div>
      </div>
    </CommonModal>
  );
}

NovoImposto.propTypes = {
  modalHook: PropTypes.shape({
    novoImpostoModal: PropTypes.bool.isRequired,
    setNovoImpostoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaImposto: PropTypes.func.isRequired,
  getDadosArquivo: PropTypes.func.isRequired,
  anoInicial: PropTypes.number.isRequired,
  anoFinal: PropTypes.number.isRequired,
};
export default NovoImposto;
